import { useState, useEffect } from 'react';
import Modal from '../shared/Modal';
import { formatTime } from '../../utils/scheduleFormat';

// Convert a raw time value (ISO "...T11:30:00Z", "11:30:00", or "11:30")
// into the 24-hour "HH:MM" string an <input type="time"> expects.
function toInputTime(raw) {
  if (!raw) return '';
  const s = String(raw);
  if (s.includes('T')) {
    const d = new Date(s);
    const h = d.getUTCHours().toString().padStart(2, '0');
    const m = d.getUTCMinutes().toString().padStart(2, '0');
    return `${h}:${m}`;
  }
  const m = s.match(/^(\d{1,2}):(\d{2})/);
  if (m) return `${m[1].padStart(2, '0')}:${m[2]}`;
  return '';
}

export default function SetMealTimeModal({ open, onClose, meal, onSave }) {
  const windowStart = toInputTime(meal?.windowStart);
  const windowEnd = toInputTime(meal?.windowEnd);
  const [time, setTime] = useState('');
  const [error, setError] = useState(false);

  // Seed the input with the team's existing pick (or the window start) each
  // time the modal opens for a meal.
  useEffect(() => {
    if (open) {
      setTime(toInputTime(meal?.chosenTime) || windowStart);
      setError(false);
    }
  }, [open, meal, windowStart]);

  if (!meal) return null;

  const mealLabel = meal.activity || 'Meal';
  const windowText = `${formatTime(windowStart)} – ${formatTime(windowEnd)}`;

  function handleSave() {
    const outOfWindow =
      !time ||
      (windowStart && time < windowStart) ||
      (windowEnd && time > windowEnd);
    if (outOfWindow) {
      setError(true);
      return;
    }
    onSave(time);
    onClose();
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Set Your ${mealLabel} Time`}
      footer={
        <>
          <button className="btn" onClick={onClose}>Cancel</button>
          <button className="btn btn-dark" onClick={handleSave}>Save Time</button>
        </>
      }
    >
      <div className="notice-bar" style={{ background: '#fffbf0', borderColor: '#d4920a', color: '#7a4f0a' }}>
        Admin has set the <strong>{mealLabel} window as {windowText}</strong>. Pick a time within this window for your team.
      </div>
      <div className="form-group" style={{ marginTop: 16 }}>
        <label className="form-label">Your Team's {mealLabel} Time</label>
        <input
          className="form-input"
          type="time"
          value={time}
          min={windowStart || undefined}
          max={windowEnd || undefined}
          onChange={(e) => { setTime(e.target.value); setError(false); }}
        />
        {error ? (
          <div style={{ fontFamily: 'var(--font-b)', fontSize: 12, fontWeight: 400, color: '#b91c1c', marginTop: 6 }}>
            Time must be within the window: {windowText}
          </div>
        ) : (
          <div style={{ fontFamily: 'var(--font-b)', fontSize: 12, fontWeight: 300, color: 'var(--muted)', marginTop: 6 }}>
            Must be within the window: {windowText}
          </div>
        )}
      </div>
    </Modal>
  );
}
